import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Search, Calendar } from 'lucide-react';
import { trpc } from '@/lib/trpc';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/Button';
import { Pagination } from '@/components/ui/Pagination';
import { EventoCard } from './components/EventoCard';

export function EventosPage() {
  const { hasPermission } = useAuth();
  const canEdit = hasPermission('ADMIN', 'FINANCEIRO', 'COORDENADOR_EVENTO');

  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const { data, isLoading } = trpc.eventos.list.useQuery({
    page,
    limit: 12,
    search: search || undefined,
  });

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Calendar className="h-6 w-6 text-gray-400" />
          <h1 className="text-2xl font-bold text-gray-900">Campanhas e Atividades</h1>
        </div>
        <Button onClick={() => navigate('/eventos/novo')} disabled={!canEdit}>
          <Plus className="mr-2 h-4 w-4" />
          Novo Evento
        </Button>
      </div>

      {/* Search */}
      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          placeholder="Buscar evento..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full rounded-lg border border-gray-300 bg-white py-2.5 pl-10 pr-4 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
        />
      </div>

      {/* Content */}
      {isLoading ? (
        <div className="flex items-center justify-center py-12">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-600 border-t-transparent" />
        </div>
      ) : data?.items.length === 0 ? (
        <div className="rounded-lg border border-gray-200 bg-white p-12 text-center">
          <Calendar className="mx-auto h-12 w-12 text-gray-300 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-1">
            Nenhum evento encontrado
          </h3>
          <p className="text-sm text-gray-500 mb-4">
            {search
              ? 'Tente ajustar sua busca'
              : 'Comece criando seu primeiro evento'}
          </p>
          {!search && (
            <Button onClick={() => navigate('/eventos/novo')} disabled={!canEdit}>
              <Plus className="mr-2 h-4 w-4" />
              Criar Evento
            </Button>
          )}
        </div>
      ) : (
        <>
          {/* Card Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {data?.items.map((evento) => (
              <EventoCard
                key={evento.id}
                evento={evento}
                onClick={() => navigate(`/eventos/${evento.id}`)}
              />
            ))}
          </div>

          {data && <Pagination meta={data.meta} onPageChange={setPage} itemLabel="eventos" />}
        </>
      )}
    </div>
  );
}

export default EventosPage;
